import type {ZodErrorMap} from "zod";
import {ZodIssueCode} from "zod";


const portugueseErrorMap: ZodErrorMap = (issue, ctx) => {

    if (issue.code === ZodIssueCode.too_small) {
        if (issue.type == "string") {
            return {message: "Precisa ter pelo menos " + issue.minimum + " caracteres"}
        }
        if (issue.type == "array") {
            return {message: "Selecione pelo menos " + issue.minimum + " registro" + (issue.minimum > 1 ? 's' : '')}
        }


    }

    if (issue.code === ZodIssueCode.invalid_type && issue.expected === "number") {
        return {message: "Informe um valor"};
    }

    if (issue.code === ZodIssueCode.invalid_type && issue.expected === "date") {
        return {message: "A data é obrigatória"};
    }

    if(issue.code === ZodIssueCode.invalid_type && issue.expected === "string") {
        return {message: "Campo obrigatório"};
    }

    return {message: ctx.defaultError};
};

export function zodSetPortugueseErrorMap (zod: any ){
    zod.setErrorMap(portugueseErrorMap);
}



